/* Glow Screen long-form PDP: one free-gift state shared by every selector on the page.
   Sources of truth:
   - Gift options: <script id="gs-gift-data"> rendered by sections/gs-free-gift-selector.liquid.
   - Selection: GS.gift (one value). Every [data-gs-gift] radio group, every [data-gs-gift-name]
     summary and every [data-gs-add] button reads it; no section keeps its own copy.
   Cart: adds Glow Screen with the chosen gift as a line-item property. If a gift option has a
   $0.00 gift variant configured (same pattern as snippets/sbc-cart-rewards.liquid), that variant
   is added too. With no gift variant configured, NO free product is added and no price changes:
   the promotion itself still has to be connected (see TODO in gs-free-gift-selector.liquid).
   sbc-cart.js wraps fetch, so a successful /cart/add.js opens the theme's cart drawer. */
(function () {
  if (window.GS) return;
  const GS = (window.GS = { gift: null, gifts: [], subs: [] });

  function readGifts() {
    const el = document.getElementById('gs-gift-data');
    if (!el) return [];
    try { return JSON.parse(el.textContent).filter(g => g && g.handle); } catch (e) { return []; }
  }

  GS.set = function (handle, source) {
    const g = GS.gifts.find(x => x.handle === handle && x.available);
    if (!g || (GS.gift && GS.gift.handle === g.handle)) return;
    GS.gift = g;
    GS.subs.forEach(fn => fn(g, source));
  };

  function optionHTML(g, name) {
    // Same markup as the server-rendered rows in gs-free-gift-selector.liquid.
    const id = `${name}-${g.handle}`;
    const media = g.image
      ? `<div class="gs-media" style="--gs-ar:1 / 1;"><img src="${g.image}" alt="" loading="lazy" width="200" height="200"></div>`
      : `<div class="gs-media" style="--gs-ar:1 / 1;"><div class="gs-ph" role="img" aria-label="${g.label} (placeholder)"><span>${g.label}</span></div></div>`;
    const value = g.available
      ? `<span class="gs-gift__value">${g.price_fmt} value <span aria-hidden="true">·</span> <b>Free</b></span>`
      : `<span class="gs-gift__value" id="${id}-so">Sold out</span>`;
    return `<div class="gs-gift__opt">
      <input type="radio" name="${name}" id="${id}" value="${g.handle}"${g.available ? '' : ` disabled aria-describedby="${id}-so"`}>
      <label class="gs-gift__card" for="${id}">${media}
        <span class="gs-gift__text"><span class="gs-gift__name">${g.title}</span>${g.short ? `<span class="gs-gift__line">${g.short}</span>` : ''}${value}</span>
        <span class="gs-gift__ctl" aria-hidden="true"></span>
      </label></div>`;
  }

  function bindGroup(group) {
    // Groups without server-rendered options (closing offer) are built from the shared data.
    if (!group.querySelector('input[type=radio]')) {
      const name = group.getAttribute('data-gs-gift') || 'gs-gift';
      const list = group.querySelector('.gs-gift__list');
      if (list) list.innerHTML = GS.gifts.slice().sort((x, y) => (y.available ? 1 : 0) - (x.available ? 1 : 0)).map(g => optionHTML(g, name)).join('');
    }
    group.addEventListener('change', e => {
      if (e.target.matches('input[type=radio]')) GS.set(e.target.value, group);
    });
    GS.subs.push(g => {
      group.querySelectorAll('input[type=radio]').forEach(r => { r.checked = r.value === g.handle; });
    });
  }

  function bindSummary(el) {
    GS.subs.push(g => { el.textContent = g.title; });
  }

  // Gift value and offer total: strings rendered by Liquid from the store's prices (price_fmt,
  // total_fmt), so JS never does money maths.
  function bindValues() {
    GS.subs.push(g => {
      document.querySelectorAll('[data-gs-gift-value]').forEach(el => { el.textContent = `${g.price_fmt} value`; });
      document.querySelectorAll('[data-gs-gift-total]').forEach(el => { if (g.total_fmt) el.textContent = g.total_fmt; });
      document.querySelectorAll('[data-gs-gift-short]').forEach(el => { el.textContent = g.short || ''; });
      document.querySelectorAll('[data-gs-gift-price]').forEach(el => { el.textContent = g.price_fmt; });
    });
  }

  async function add(btn) {
    const err = btn.closest('form, .gs-buy')?.querySelector('[data-gs-error]');
    if (!GS.gift) { if (err) err.hidden = false; return; }
    if (err) err.hidden = true;
    const main = Number(btn.getAttribute('data-gs-add'));
    const items = [{ id: main, quantity: 1, properties: { 'Free gift': GS.gift.title } }];
    if (GS.gift.gift_variant) items.push({ id: GS.gift.gift_variant, quantity: 1, properties: { '_gs_gift_for': String(main) } });
    btn.setAttribute('aria-busy', 'true'); btn.disabled = true;
    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const res = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      if (!res.ok) throw new Error((await res.json().catch(() => ({}))).description || res.statusText);
      if (!window.SbcCart) window.location.href = `${root}cart`;
    } catch (e) {
      if (err) { err.textContent = e.message || 'Could not add to bag. Please try again.'; err.hidden = false; }
    } finally {
      btn.removeAttribute('aria-busy'); btn.disabled = false;
    }
  }

  function init() {
    GS.gifts = readGifts();
    document.querySelectorAll('[data-gs-gift]').forEach(bindGroup);
    document.querySelectorAll('[data-gs-gift-name]').forEach(bindSummary);
    bindValues();
    document.querySelectorAll('[data-gs-add]').forEach(btn => btn.addEventListener('click', e => { e.preventDefault(); add(btn); }));
    // Default: the option flagged default, else the first in-stock option. The selector stays editable.
    const first = GS.gifts.find(g => g.default && g.available) || GS.gifts.find(g => g.available);
    if (first) GS.set(first.handle, null);
    else document.querySelectorAll('[data-gs-add]').forEach(b => b.setAttribute('aria-disabled', 'true'));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Hero video: respect reduced-motion (show the poster frame), and retry play() for browsers that
   ignore the autoplay attribute until the element is in view (muted autoplay is always allowed). */
(function () {
  const v = document.querySelector('.gs-hero__video');
  if (!v) return;
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) { v.removeAttribute('autoplay'); v.pause(); return; }
  const tryPlay = () => { const p = v.play(); if (p && p.catch) p.catch(() => {}); };
  if (v.readyState >= 2) tryPlay(); else v.addEventListener('loadeddata', tryPlay, { once: true });
})();

/* Gift tiles ([data-gs-gift-media]) show the selected gift's card image. */
(function () {
  const run = () => {
    if (!window.GS) return;
    const paint = g => document.querySelectorAll('[data-gs-gift-media]').forEach(box => {
      if (!g.image_lg) return;
      box.innerHTML = `<div class="gs-media" style="--gs-ar:1 / 1;"><img src="${g.image_lg}" alt="${g.title} (free gift)" width="700" height="700" loading="lazy"></div>`;
    });
    GS.subs.push(paint);
    if (GS.gift) paint(GS.gift);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* Hero slideshow: dots scroll the native scroll-snap track; the active dot follows the scroll. */
(function () {
  const run = () => document.querySelectorAll('[data-gs-slides]').forEach(root => {
    const track = root.querySelector('.gs-slides__track');
    const dots = [...root.querySelectorAll('[data-gs-slide-to]')];
    if (!track || !dots.length) return;
    const slides = [...track.children];
    // Slides are narrower than the track (peek), so the active slide is the one whose left edge is nearest.
    const nearest = () => { let best = 0, d = Infinity; slides.forEach((s, k) => { const x = Math.abs(s.offsetLeft - track.offsetLeft - track.scrollLeft); if (x < d) { d = x; best = k; } }); return best; };
    dots.forEach(d => d.addEventListener('click', () => {
      const i = Number(d.dataset.gsSlideTo);
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }));
    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = nearest();
        dots.forEach((d, k) => d.toggleAttribute('aria-current', k === i));
      });
    }, { passive: true });
    track.addEventListener('keydown', e => {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      const i = nearest() + (e.key === 'ArrowRight' ? 1 : -1);
      const t = slides[Math.max(0, Math.min(slides.length - 1, i))];
      track.scrollTo({ left: t.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
